import { Button, ColorVariant, CornerRadius, MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const ButtonDemo = () => {
  const base = {
    fullWidth: false,
    alignment: 'parent',
    margin: 0 as any,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
  }

  const args = [
    {
      ...base,
      fullWidth: true,
      badgeText: '',
      colorVariant: 'primary-50' as ColorVariant,
      size: 'md' as any,
      cornerRadius: 'medium' as CornerRadius,
      trailingIcon: false,
      disabled: false,
      typography: 'label-medium',
      icon: '',
      border: false,
      elevation: false,
      title: 'Full Width',
    },
    {
      ...base,
      badgeText: 'New',
      colorVariant: 'primary-50' as ColorVariant,
      size: 'md' as any,
      cornerRadius: 'medium' as CornerRadius,
      trailingIcon: false,
      disabled: false,
      typography: 'label-medium',
      icon: 'home',
      border: false,
      elevation: false,
      title: 'Icon & Badge',
    },
    {
      ...base,
      badgeText: '',
      colorVariant: 'primary-50' as ColorVariant,
      size: 'md' as any,
      cornerRadius: 'full' as CornerRadius,
      trailingIcon: false,
      disabled: false,
      typography: 'label-medium',
      icon: '',
      border: false,
      elevation: false,
      title: 'Full Radius',
    },
    {
      ...base,
      badgeText: '',
      colorVariant: 'primary-50' as ColorVariant,
      size: 'md' as any,
      cornerRadius: 'medium' as CornerRadius,
      trailingIcon: true,
      disabled: true,
      typography: 'label-medium',
      icon: '',
      border: false,
      elevation: false,
      title: 'Disabled',
    },
  ]

  return (
    <LayoutDemo title='Button' bgColor='var(--color-primary-90)' opacity={0.09}>
      <div className='flex flex-col gap-4 w-full h-full items-center justify-center'>
        {args.map((arg, i) => {
          const {
            title,
            fullWidth,
            alignment,
            margin,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
            ...buttonProps
          } = arg

          const { colorVariant, typography, icon, ...props } = buttonProps

          return (
            <Button
              key={i}
              {...props}
              id={`button-example-${i}`}
              margin={{
                top: `${margin}px`,
                right: `${margin}px`,
                bottom: `${margin}px`,
                left: `${margin}px`,
              }}
              padding={{
                top: `${paddingTop}px`,
                right: `${paddingRight}px`,
                bottom: `${paddingBottom}px`,
                left: `${paddingLeft}px`,
              }}
              backgroundColor={'primary-70'}
              fullWidth={fullWidth}
              colorVariant={colorVariant}
              labelTypography={{ typography }}
              icon={icon ? <MaterialIcon icon={icon} size={18} /> : undefined}
            >
              {title}
            </Button>
          )
        })}
      </div>
    </LayoutDemo>
  )
}
